import React from 'react';
import Html from 'react-pdf-html';
import { Page, Document, StyleSheet, Text, View } from '@react-pdf/renderer';
import { displayDateTime } from '@iso/lib/helpers/utility';

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft:60,
        paddingRight:60,
        lineHeight: 1.5,
        flexDirection: 'column',
    },
    title:{
        width: '100%',
        height: 26,
        padding:'5px 5px 0px 5px',
        border: '1px solid #000000',
        color:'#000000',
        fontFamily: 'Helvetica-Bold',
        fontSize:12,
        borderRadius:'3px',
        textAlign:'center'
    },
    reportTitle:{
        fontSize: 10,
        marginTop: 5,
        fontFamily: 'Helvetica-Bold',
        textIndent:'5px'
    },
    container:{
        paddingTop:'3px',
        paddingLeft:'3px',
        paddingRight:'3px',
        height:'20px',
        fontSize:10,
        // flexDirection: 'row',
        fontWeight:'normal',
        border: '1px solid #000000',
        borderRadius:'3px'
    },
    textCenter:{
        textAlign:'center'
    },
    textRight:{
        textAlign:'right'
    },
    textHtml:{
        fontSize:10,
        whiteSpace: 'pre-line'
    },
    textSmall:{
        fontSize:9
    }
});

const CartaCorrecao = ({data}) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.title}>
                    <Text key={'title'}>CARTA DE CORREÇÃO</Text>
                </View>
                <View style={{flexDirection: 'row'}}>
                    <View style={{width:'100%'}}>
                        <Text style={{...styles.reportTitle, ...styles.textCenter}}>Chave de acesso</Text>
                        <View style={{...styles.container, ...styles.textCenter}}>
                            <Text>{data.sefaz.chave}</Text>
                        </View>
                    </View>
                </View>
                <View style={{flexDirection: 'row'}}>
                    {/* <View style={{width:'25%', 'marginRight':'0%'}}>
                        <Text style={styles.reportTitle}>Orgão recepção</Text>
                        <View style={styles.container}>
                            <Text>{data.orgao_recepcao}</Text>
                        </View>
                    </View> */}
                    <View style={{width:'33%'}}>
                        <Text style={{...styles.reportTitle, ...styles.textCenter}}>CNPJ</Text>
                        <View style={ {...styles.container, ...styles.textCenter}}>
                            <Text>{data.cpf_cnpj}</Text>
                        </View>
                    </View>
                    <View style={{width:'33%', 'marginLeft':'1%'}}>
                        <Text style={{...styles.reportTitle, ...styles.textCenter}}>Ambiente</Text>
                        <View style={{...styles.container, ...styles.textCenter}}>
                            <Text>{data.ambiente}</Text>
                        </View>
                    </View>
                    <View style={{width:'34%', 'marginLeft':'1%'}}>
                        <Text style={{...styles.reportTitle, ...styles.textRight}}>Data de emissão</Text>
                        <View style={ {...styles.container, ...styles.textRight}}>
                            <Text>{displayDateTime(data.sefaz['data-emissao'], true)}</Text>
                        </View>
                    </View>
                    {/* <View style={{width:'25%', 'marginLeft':'1%'}}>
                        <Text style={{...styles.reportTitle, ...styles.textRight}}>Versão</Text>
                        <View style={ {...styles.container, ...styles.textRight}}>
                            <Text style={styles.textRight}>1.00</Text>
                        </View>
                    </View> */}
                </View>
                {/* <View style={{flexDirection: 'row'}}>
                    <View style={{width:'50%', 'marginLeft':'1%'}}>
                        <Text style={{...styles.reportTitle, ...styles.textRight}}>ID Evento</Text>
                        <View style={ {...styles.container, ...styles.textRight, ...styles.textSmall}}>
                            <Text>{data.id}</Text>
                        </View>
                    </View>
                </View> */}
                <>
                    <Text style={styles.reportTitle}>Retorno SEFAZ</Text>
                    <View style={{...styles.container, ...{height:'22px'}}}>
                        <Text><Html style={styles.textHtml}>{data.sefaz.mensagem.split('\n').join("<br/>")}</Html></Text>
                    </View>
                </>
                <>
                    <Text style={styles.reportTitle}>Texto da carta de correção</Text>
                    <View style={{...styles.container, ...{height:'120px'}}}>
                        <Text><Html style={styles.textHtml}>{data.motivo.split('\n').join("<br/>")}</Html></Text>
                    </View>
                </>
                <View style={{flexDirection: 'row'}}>
                    {/* <View style={{width:'30%', 'marginRight':'1%'}}>
                        <Text style={styles.reportTitle}>Mensagem de autorização</Text>
                        <View style={styles.container}>
                            <Text>1.00</Text>
                        </View>
                    </View>
                    <View style={{width:'40%', 'marginLeft':'1%'}}>
                    <Text style={{...styles.reportTitle, ...styles.textCenter}}>Protocolo</Text>
                        <View style={ {...styles.container, ...styles.textCenter}}>
                            <Text>{data.protocolo}</Text>
                        </View>
                    </View> */}
                    {/* <View style={{width:'30%', 'marginLeft':'1%'}}>
                        <Text style={{...styles.reportTitle, ...styles.textRight}}>Data de emissão</Text>
                        <View style={ {...styles.container, ...styles.textRight}}>
                            <Text>{displayDateTime(data.sefaz['data-emissao'], true)}</Text>
                        </View>
                    </View> */}
                </View>
                <>
                    <Text style={styles.reportTitle}>Condições de uso</Text>
                    <View style={{...styles.container, ...{height:'100px'}}}>
                        <Text>A Carta de Correção é disciplinada pelo parágrafo 1o-A do art. 7o do Convênio S/N, de 15 de dezembro de 1970 e pode ser utilizada para regularização de erro ocorrido na emissão de documento fiscal, desde que o erro não esteja relacionado com: I - as variáveis que determinam o valor do imposto tais como: base de cálculo, alíquota, diferença de preço, quantidade, valor da operação ou da prestação; II - a correção de dados cadastrais que implique mudança do remetente ou do destinatário; III - a data de emissão ou de saída. </Text>
                    </View>
                </>
            </Page>
        </Document>
    )
};
  
export default CartaCorrecao